<script>

import CommonService from '../../services/common';
import Dialog from 'primevue/dialog';
import TreeTable from 'primevue/treetable';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Column from 'primevue/column';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),

    components: { TreeTable, Button, InputText, ResponsiveButton },
    data(){
        return{
            nodes: null,
            selectedItem: null,
            aggregation: 'Bilanci',
            nodesColumns: null,
            addProductVisible: false,
            editProductVisible: false,
            newProduct: {
                properties:[{}],
                aggregations: [{id: 0, properties:[{}], parents: [{id: 0, properties:[{}]}]}],
            },
            products: [],
            expandedRows: [],
            addAggregationPropertyDialogVisible: false,
            addParentPropertyDialogVisible: false,
            maxAggregationId: 0,
            maxParentId: 0,
            selectedAggregation: null,
            selectedParent: null,
            addProductSubmitted: false,
            enableEdit: false,
        }
    },
    validations(){
        return {
            newProduct: {
                data: {required},
            },
        }
    },
    mounted(){
        CommonService.loadGeneric('masterdata/product-combo', {}, response => {
            if(response.success){
                this.products = response.data;
            }
        });
    },
    watch: {
        addProductVisible(newValue) {
            if(!newValue) {
                this.addProductSubmitted = false;
                this.selectedAggregation = null;
                this.newProduct = {
                    properties:[{}],
                    aggregations: [{id: 0, properties:[{}], parents: [{id: 0, properties:[{}]}]}],
                }
            }
        },
    },
    computed: {
        hasAggregation(){
            return this.newProduct?.aggregations && this.newProduct.aggregations.some((item) => item.name);
        },
    },
    methods: {
        loadAggregation(){
            this.nodes = [];
            this.selectedItem = null;

            CommonService.loadGeneric(`pm-aggregation-tree?aggregation=${this.aggregation}`, {}, response => {
                if(response.success){
                    this.nodes = this.generateTreeTableNodes(response.data.data.root);
                }
            });
        },
        generateTreeTableNodes(data, parentKey = null) {
            const nodes = [];
            
            for (const key in data) {
                const item = data[key];
                const node = {
                    key: parentKey ? `${parentKey}-${key}` : key,
                    label: key,
                    data: {
                        name: key,
                    },
                    children: []
                };

                if (Array.isArray(item)) {
                for (const childItem of item) {
                    const childNode = {
                        key: `${node.key}-${childItem.smartSimCode}`,
                        label: childItem.name,
                        data: childItem
                    };
                    node.children.push(childNode);
                }
                } else if (typeof item === 'object') {
                    node.children = this.generateTreeTableNodes(item, node.key);
                }
                nodes.push(node);
            }
            return nodes;
        },
        submitAddProduct(){
            this.addProductSubmitted = true;
            
            if(this.hasAggregation && !this.v$.invalid) {

                const body = {
                    smartSimId: this.newProduct.data.value,
                    smartSimCode: this.newProduct.data.extraData.code,
                    name: this.newProduct.data.extraData.englishDescription,
                    properties: this.newProduct.properties,
                    aggregations: this.newProduct.aggregations,
                };

                console.log('body', body)

                CommonService.createItem('pm-product', body, response => {
                    if(response.success){
                        console.log('data', response.data);
                    }
                })

            } else {
                console.log('non invio il form');
            }
        },
        onPropertyCellEditComplete({field, newValue, index}){
            this.newProduct.properties[index][field] = newValue;
        },
        onAggregationCellEditComplete({field, newValue, index}){
            this.newProduct.aggregations[index][field] = newValue;
        },
        onParentCellEditComplete({field, newValue, index}){
            this.selectedAggregation.parents[index][field] = newValue;
        },
        onAggregationPropertyCellEditComplete({index, field, newValue}){
            this.selectedAggregation.properties[index][field] = newValue;
        },
        onParentPropertyCellEditComplete({index, field, newValue}){
            this.selectedParent.properties[index][field] = newValue;
        },
        onDeleteAggregation(data){
            this.selectedAggregation = (this.selectedAggregation.id === data.id) ? null : this.selectedAggregation;
            this.newProduct.aggregations = this.newProduct.aggregations.filter(({id}) => id !== data.id)
            if (!this.newProduct.aggregations.length) this.newProduct.aggregations.push({id: ++this.maxAggregationId});
        },
        onDeleteParent(data){
            this.selectedAggregation.parents = this.selectedAggregation.parents.filter(({id}) => id !== data.id)
            if (!this.selectedAggregation.parents.length) this.selectedAggregation.parents.push({id: ++this.maxParentId});
        },
        editItem(){
            console.log('this.selectedItem', this.selectedItem);
            this.addProductVisible = true;

            CommonService.loadGeneric(`pm-product-by-code-and-aggregation`, {code: this.selectedItem.smartSimCode, aggregation: this.aggregation}, response => {
                if(response.success){
                    console.log('response', response.data.data[0]);
                    const product = response.data.data[0];
                    this.newProduct.data = this.products.find((item) => item.extraData.code == product.smartSimCode);
                    this.newProduct.aggregations = product.aggregations.map((item) => ({id:++this.maxAggregationId, ...item}));
                    this.newProduct.aggregations.forEach((aggregation, index) => {
                        this.newProduct.aggregations[index].parents = aggregation.parents.map((item) => ({id: ++this.maxParentId, ...item}) )
                        this.newProduct.aggregations[index].parents.forEach((parent) => {
                            parent.properties = Object.entries(parent.properties).map(([key, value]) => ({key, value}))
                        })
                    })
                    this.newProduct.aggregations.forEach((aggregation, index) => {
                        this.newProduct.aggregations[index].properties = Object.entries(aggregation.properties).map(([key, value]) => ({key, value}))
                    })
                }
            });
        },
        onNodeSelect({data}){
            this.enableEdit = !!data.smartSimCode;
            this.selectedItem = data;
        }
    },
}

</script>

<template>
    <main>
        <div class="grid">
            <div class="col-12 lg:col-4">
                <label for="aggregation">{{$t('aggregation')}}</label>
                <InputText id="aggregation" class="w-full" type="text" v-model="aggregation"/>
            </div>
            <div class="col-12 lg:col-8">
                <Button :label="$t('btn.load')" icon="pi pi-sync" class="m-4 p-button-outlined" @click="loadAggregation"  />
                <Button :label="$t('btn.add')" icon="pi pi-plus" class="m-4 p-button-outlined" @click="addProductVisible = true"  />
                <Button :label="$t('btn.edit')" icon="pi pi-pencil" class="m-4 p-button-outlined" @click="editItem" :disabled="!enableEdit" />
            </div>
        </div>
        <!-- 
        <Button :label="$t('btn.edit')" icon="pi pi-pencil" class="m-4 p-button-outlined" @click="openEditDialog" :disabled="!selectedItem" />
        <Button :label="$t('btn.delete')" icon="pi pi-trash" class="m-4 p-button-outlined" @click="openDeleteDialog" :disabled="!selectedItem" /> -->
        
        <TreeTable 
            :onNodeSelect="onNodeSelect"
            :value="nodes" 
            selectionMode="single" >
            <Column field="name" header="Name" :expander="true"></Column>
            <Column field="smartSimCode" header="SmartSimCode"></Column>
            <Column field="properties" header="Extra Data">
                <template #body="element">
                    <template v-for="list, property in element.node.data?.properties" :key="property">
                        <div class="mb-2">
                            <span class="p-badge p-badge-lg p-badge-info" v-if="Object.values(list).length">
                                {{ property }}
                            </span>
                            <span class="block" v-for="key, value in list" :key="value"> {{ value+ ": " + key }}</span>
                        </div>
                    </template>
                </template>
            </Column>
        </TreeTable>

        <Dialog :header="$t('btn.add')" v-model:visible="addProductVisible" :modal="true" :style="{width: '75vw'}">
            <div class="grid formgrid">
                <div class="col-12 lg:col-6 field">
                    <div>
                        <label :class="{'p-error':v$.newProduct.data.$invalid && addProductSubmitted}" for="product">{{$t('product.fk')}}</label>
                        <Dropdown 
                            name="product"
                            class="w-full"
                            :class="{'p-invalid':v$.newProduct.data.$invalid && addProductSubmitted}"
                            :options="products"
                            optionLabel="label"
                            v-model="newProduct.data" />
                        <div v-if="(v$.newProduct.data.$invalid && addProductSubmitted) || v$.newProduct.data.$pending.$response">
                            <small class="p-error" v-for="error in v$.newProduct.data.$silentErrors" :key="error.$validator" >
                                {{error.$message}}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col-12">
                    <span class="title">{{ $t('productAggregation.properties') }}</span>
                    <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="this.newProduct.properties.push({})" />
                    <Button icon="pi pi-minus" class="p-button-sm p-button-danger ml-2" @click="(this.newProduct.properties.length >= 1) && this.newProduct.properties.pop() && (!this.newProduct.properties.length && this.newProduct.properties.push({}))" />
                    <div>
                        <DataTable :value="newProduct.properties" showGridlines stripedRows editMode="cell" @cell-edit-complete="onPropertyCellEditComplete">
                            <Column field="key" :header="$t('productAggregation.property')">
                                <template #editor="{ data, field }">
                                    <InputText 
                                        class="w-full"
                                        v-model="data[field]" />
                                </template>
                            </Column>
                            <Column field="value" :header="$t('productAggregation.value')" >
                                <template #editor="{ data, field }">
                                    <InputText 
                                        class="w-full"
                                        v-model="data[field]" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </div>
                <div class="col-12">
                    <span class="title">{{ $t('productAggregation.aggregations') }}</span>
                    <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="this.newProduct.aggregations.push({id: ++this.maxAggregationId})" />
                    <div>
                        <DataTable :value="newProduct.aggregations" v-model:selection="selectedAggregation" dataKey="id" v-model:expandedRows="expandedRows" showGridlines stripedRows editMode="cell" @cell-edit-complete="onAggregationCellEditComplete">
                            <Column selectionMode="single" headerStyle="width: 3rem"></Column>
                            <Column style="width:8rem">
                                <template #body="slotProps">
                                    <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-rounded p-button-outlined" :disabled="!slotProps.data.name" @click="addAggregationPropertyDialogVisible = true; selectedAggregation = slotProps.data" />
                                    <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" :disabled="!slotProps.data.name" @click="onDeleteAggregation(slotProps.data, $event)" />
                                </template>
                            </Column>
                            <Column field="name" :header="$t('productAggregation.aggregation')" >
                                <template #body="{data: {name}}">
                                        <span><i v-if="!hasAggregation && addProductSubmitted" class="pi pi-exclamation-circle text-red text-xl mr-2" v-tooltip="'Value is required'"></i>{{ name }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputText 
                                        class="w-full"
                                        v-model="data[field]" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </div>
                <div class="col-12" v-if="selectedAggregation">
                    <span class="title">{{ $t('productAggregation.parents') }}</span>
                    <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="selectedAggregation.parents.push({id: ++this.maxParentId})" />
                    <div>
                        <DataTable :value="selectedAggregation.parents" showGridlines stripedRows groupRowsBy="rowspan" rowGroupMode="subheader" editMode="cell" @cell-edit-complete="onParentCellEditComplete">
                            <Column style="width:8rem">
                                <template #body="slotProps">
                                    <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-rounded p-button-outlined" :disabled="!(slotProps.data.level === 0 || slotProps.data.level) || !slotProps.data.name" @click="addParentPropertyDialogVisible = true; selectedParent = slotProps.data" />
                                    <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" :disabled="!(slotProps.data.level === 0 || slotProps.data.level) || !slotProps.data.name" @click="onDeleteParent(slotProps.data, $event)" />
                                </template>
                            </Column>
                            <Column field="name" :header="$t('productAggregation.name')">
                                <template #editor="{ data, field }">
                                    <InputText 
                                        class="w-full"
                                        v-model="data[field]" />
                                </template>
                            </Column>
                            <Column field="level" :header="$t('productAggregation.level')" >
                                <template #editor="{ data, field }">
                                    <InputNumber 
                                        class="w-full"
                                        v-model="data[field]" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </div>
            </div>
            
            <template #footer>
                <Button :label="$t('btn.cancel')" icon="pi pi-close" class="m-4 p-button-outlined" @click="addProductVisible = false"  />
                <Button :label="$t('btn.save')" icon="pi pi-save" class="m-4 p-button-outlined" @click="submitAddProduct"  />
            </template>
        </Dialog>
        <Dialog :header="$t('productAggregation.addPropertyToAggregation') + ' ' + selectedAggregation?.name" v-model:visible="addAggregationPropertyDialogVisible" :modal="true" :style="{width: '50vw'}">
            <div class="grid">
                <div class="col-12">
                    <span class="title">{{ $t('productAggregation.properties') }}</span>
                    <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="selectedAggregation.properties ? selectedAggregation.properties.push({}) : selectedAggregation.properties = [{}]" />
                    <Button icon="pi pi-minus" class="p-button-sm p-button-danger ml-2" @click="(selectedAggregation.properties.length >= 1) && selectedAggregation.properties.pop() && (!selectedAggregation.properties.length && selectedAggregation.properties.push({}))" />
                    <DataTable :value="selectedAggregation.properties" showGridlines stripedRows editMode="cell" @cell-edit-complete="onAggregationPropertyCellEditComplete" >
                        <Column field="key" :header="$t('productAggregation.property')">
                            <template #editor="{ data, field }">
                                <InputText 
                                    class="w-full"
                                    v-model="data[field]" />
                            </template>
                        </Column>
                        <Column field="value" :header="$t('productAggregation.value')" >
                            <template #editor="{ data, field }">
                                <InputText 
                                    class="w-full"
                                    v-model="data[field]" />
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </Dialog>
        <Dialog :header="$t('productAggregation.addPropertyToParent') + ' ' + selectedParent?.name" v-model:visible="addParentPropertyDialogVisible" :modal="true" :style="{width: '50vw'}">
            <div class="grid">
                <div class="col-12">
                    <span class="title">{{ $t('productAggregation.properties') }}</span>
                    <Button icon="pi pi-plus" class="p-button-sm p-button-info ml-2" @click="selectedParent.properties ? selectedParent.properties.push({}) : selectedParent.properties = [{}]" />
                    <Button icon="pi pi-minus" class="p-button-sm p-button-danger ml-2" @click="(selectedParent.properties.length >= 1) && selectedParent.properties.pop() && (!selectedParent.properties.length && selectedParent.properties.push({}))" />
                    <DataTable :value="selectedParent.properties" showGridlines stripedRows editMode="cell" @cell-edit-complete="onParentPropertyCellEditComplete" >
                        <Column field="key" :header="$t('productAggregation.property')">
                            <template #editor="{ data, field }">
                                <InputText 
                                    class="w-full"
                                    v-model="data[field]" />
                            </template>
                        </Column>
                        <Column field="value" :header="$t('productAggregation.value')" >
                            <template #editor="{ data, field }">
                                <InputText 
                                    class="w-full"
                                    v-model="data[field]" />
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </Dialog>
    </main>
</template>

<style scoped>

.title{
  font-size: large;
}

.invalid{
    background-color: red;
}

</style>